export function Clear() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });
    };
}

export function GoToStep1() {
    return function(dispatch) {
        dispatch({
            type: 'APP/GO_TO_STEP_1',
        });
    };
}

export function GoToStep2() {
    return function(dispatch) {
        dispatch({
            type: 'APP/GO_TO_STEP_2',
        });
    };
}

export function DisableStockCheck() {
    return function(dispatch) {
        dispatch({
            type: 'APP/DISABLE_STOCK_CHECK',
        });
    };
}

export function EnableStockCheck() {
    return function(dispatch) {
        dispatch({
            type: 'APP/ENABLE_STOCK_CHECK',
        });
    };
}
